import { useEffect } from "react";

export const useFullscreenLayoutEffect = (
  isFullscreen: boolean,
  onExit: () => void,
) => {
  useEffect(() => {
    if (!isFullscreen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onExit();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isFullscreen, onExit]);

  useEffect(() => {
    const dispatchResize = () => window.dispatchEvent(new Event("resize"));
    const animationFrame = window.requestAnimationFrame(dispatchResize);
    const timeout = window.setTimeout(dispatchResize, 250);

    return () => {
      window.cancelAnimationFrame(animationFrame);
      window.clearTimeout(timeout);
    };
  }, [isFullscreen]);
};
